import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter, Switch, Route} from "react-router-dom";
import RequirementMain from './requirement';
import AnalyzeResumes from './analyzeResume';
import MatchMaking from './requirement/matchmaking';
import Header from './header';

ReactDOM.render(
  <BrowserRouter>
  <Header/>
      <Switch>
        <Route exact path="/" component= { App }/>
        <Route path="/post-requirement" component= { RequirementMain }/>
        <Route path="/analyzed-resumes"component={ AnalyzeResumes }/>
        <Route path="/analyzed-jd"component={ AnalyzeResumes }/>
        <Route path="/matchmaking" component= { MatchMaking }/>
      </Switch>
    </BrowserRouter>,
  
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
